<script setup>
import { useI18n } from 'vue-i18n'
defineProps({ rental: { type: Object, required: true } })
const { t } = useI18n()

function statusLabel(status) {
  return t(`supplier_portal.status.${status}`, status)
}
</script>

<template>
  <tr>
    <td>{{ rental.from }} → {{ rental.to }}</td>
    <td><span :class="['pill', `pill--${rental.status}`]">{{ statusLabel(rental.status) }}</span></td>
  </tr>
</template>

<style scoped>
.pill { display: inline-block; padding: 0.15rem 0.5rem; border-radius: 999px; font-size: 0.75rem; }
.pill--active    { background: color-mix(in oklch, var(--accent) 16%, var(--surface)); color: var(--accent); }
.pill--pending   { background: color-mix(in oklch, var(--warn) 14%, var(--surface)); color: var(--warn); }
.pill--returned  { background: color-mix(in oklch, var(--ok) 14%, var(--surface)); color: var(--ok); }
.pill--cancelled { background: color-mix(in oklch, var(--muted) 14%, var(--surface)); color: var(--muted); }
</style>
